import React from "react";
import Link from "next/link";
import classNames from "classnames";

import Avatar from "@/components/Avatar";
import { applicationRoutes } from "@/helpers/applicationRouting";
import Typography from "@/components/Typography";
import PodcastIcon from "@/icons/podcast-small.svg";
import ArticleIcon from "@/icons/article.svg";
import FollowAuthorButton from "@/components/FollowAuthorButton";

import styles from "./AuthorTile.module.scss";
import { AuthorTileInterface } from "./AuthorTile.interface";

export const AuthorTile: React.FC<AuthorTileInterface> = ({
  name,
  avatar,
  podcasts,
  articles,
  followed,
  slug,
  className,
}) => (
  <div className={classNames(styles.tile, className)}>
    <Link
      href={{ pathname: `${applicationRoutes.AUTHOR}[slug]` }}
      as={applicationRoutes.AUTHOR + slug}
    >
      <a title={name} className={styles.avatar}>
        <Avatar src={avatar.url} alt={name} size="large" />
      </a>
    </Link>

    <div className={styles.meta}>
      <div>
        <Typography variant="h5" component="h5" className={styles.name}>
          <Link
            href={{ pathname: `${applicationRoutes.AUTHOR}[slug]` }}
            as={applicationRoutes.AUTHOR + slug}
          >
            <a title={name} className={styles.link}>
              {name}
            </a>
          </Link>
        </Typography>

        {podcasts?.main && (
          <Link
            href={{ pathname: `${applicationRoutes.AUTHOR}[slug]` }}
            as={applicationRoutes.AUTHOR + slug}
          >
            <a className={styles.content}>
              <Typography
                variant="small"
                component="p"
                className={styles.content}
              >
                <PodcastIcon className={styles.icon} /> {podcasts.main.title}
                {podcasts.remainingCount > 0 &&
                  `, +${podcasts.remainingCount} więcej`}
              </Typography>
            </a>
          </Link>
        )}

        {!!articles?.count && (
          <Typography variant="small" component="p">
            <Link
              href={{ pathname: `${applicationRoutes.AUTHOR}[slug]` }}
              as={applicationRoutes.AUTHOR + slug}
            >
              <a className={styles.content}>
                <ArticleIcon className={styles.icon} />
                {articles.count}
                {articles.count === 1 && " artykuł"}
                {articles.count > 1 && articles.count < 5 && " artykuły"}
                {articles.count >= 5 && " artykułów"}
              </a>
            </Link>
          </Typography>
        )}
      </div>

      <FollowAuthorButton
        size="big"
        variant="primary"
        followed={followed}
        slug={slug}
        className={styles.bookmark}
      />
    </div>
  </div>
);

export default AuthorTile;
